import React, { useEffect } from 'react';
import { createContext, useContext, useState } from 'react';
import * as apis from '../utils/apis';

const VendorPointSolutionContext = createContext();

export const VendorSolutionProvider = ({ children }) => {
  const [selectedOrgSearch, setSelectedOrgSearch] = useState(null);
  const [selectedOrgNode, setSelectedOrgNode] = useState(null);
  const [vendorPoints, setVendorPoints] = useState([]);
  const [selectedListOrg, setSelectedListOrg] = useState([])
  const [categories, setCategories] = useState([])

  useEffect(() => {
    apis.fetchVendorProgramCategories()
      .then(categories => setCategories(categories))

    apis.fetchVendorPoints()
      .then(vendorPoints => setVendorPoints(vendorPoints))
  }, []);

  const value = {
    selectedOrgSearch,
    setSelectedOrgSearch,
    selectedOrgNode,
    setSelectedOrgNode,
    vendorPoints,
    categories,
    selectedListOrg,
    setSelectedListOrg
  };

  return (
    <VendorPointSolutionContext.Provider value={value}>
      {children}
    </VendorPointSolutionContext.Provider>
  );
}

export const useVendorPointSolutionContext = () => useContext(VendorPointSolutionContext);
